import { faCalendarRangeSolid, faCalendarWeekSolid, FaIcon } from '@/lib/fa'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const CalendarDayInfoActions = ({ formattedDate }: { formattedDate: string }) => {
  const navigate = useNavigate()
  const { companyId, driverId } = useParams<{
    companyId: string
    driverId: string
  }>()

  const goTo = (target: 'daily' | 'weekly') => {
    const segment = target === 'daily' ? 'dailyActivity' : 'weeklyActivity'
    navigate(
      `/et/company/${companyId}/driverModule/activities/driver/${driverId}/${segment}/${formattedDate}`,
    )
  }

  return (
    <div className="tw-flex tw-items-center">
      <div
        onClick={() => goTo('weekly')}
        className="tw-flex tw-flex-1 tw-items-center tw-justify-center  tw-gap-1 tw-py-4 tw-cursor-pointer tw-rounded hover:tw-bg-base-200"
      >
        <FaIcon icon={faCalendarRangeSolid} className="tw-text-primary" />
        <span className="tw-text-sm tw-text-primary">
          Idź na wykres tygodniowy
        </span>
      </div>
      <div
        onClick={() => goTo('daily')}
        className="tw-flex tw-flex-1 tw-items-center  tw-justify-center tw-gap-1 tw-py-4 tw-cursor-pointer tw-rounded hover:tw-bg-base-200"
      >
        <FaIcon icon={faCalendarWeekSolid} className="tw-text-primary" />
        <span className="tw-text-sm tw-text-primary">
          Idź na wykres dzienny
        </span>
      </div>
    </div>
  )
}

export default CalendarDayInfoActions
